import { confirm } from "devextreme/ui/dialog";
import { useContext } from "react";
import { useGetCompany } from "../../../../api/company";
import { AR, BusinessFlow, FileTypes, ROType } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitInvoice } from "../api/submit-invoice";
import { RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderFiles from "./RetailOrderFiles";

export default function COCFiles() {

	const { order, refetchOrder } = useContext(RetailOrderContext);
	const dealer = useGetCompany(order.details.dealerCompanyID);

	const cocFileTypeName = order.details.isDeliveryOnly ? 'POD' : 
		dealer.data?.businessFlowID == BusinessFlow.Lowes ? 'COC' : 'AOC';

	const submitInvoice = useSubmitInvoice(
		order.details.retailOrderID,
		order.details.cfiInvoiceNumber,
		() => {
			showSuccessMessage('Files have been submitted');
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	);

	if (order.details.roTypeID !== ROType.Measure) {
		return (
			<RetailOrderFiles
				fileTypes={[FileTypes.COC, FileTypes.CfiInvoice, FileTypes.PostInstallChecklist]}
				defaultFileType={FileTypes.COC}
				buttonCaption={order.details.activeARs.includes(AR.CfiToUploadCocInvoice) ?
					('Upload ' + cocFileTypeName) : undefined}
				onFileAdded={(fileType: FileTypes) => {
					if (fileType === FileTypes.COC) {
						confirm("Do you want to submit the file?", "Submit File")
							.then((result) => {
								if (result) {
									submitInvoice.mutate();
								}
							});
					}
				}}
			/>
		)
	}
	else if (dealer.data?.businessFlowID !== BusinessFlow.Lowes)
		return (
			<RetailOrderFiles
				fileTypes={[FileTypes.PostTemplateDrawing, FileTypes.CfiInvoice]}
				defaultFileType={FileTypes.PostTemplateDrawing}
				buttonCaption={order.details.activeARs.includes(AR.CfiToUploadCocInvoice) ?
					'Upload Post Template Drawing' : undefined}
				onFileAdded={(fileType: FileTypes) => {
					if (fileType === FileTypes.PostTemplateDrawing) {
						confirm("Do you want to submit the file?", "Submit File")
							.then((result) => {
								if (result) {
									submitInvoice.mutate();
								}
							});
					}
				}}
			/>
		)
	else {
		return <></>;
	}
}
